module.exports = __webpack_public_path__ + "static/media/carrossel4.b2a50e06.jpg";